import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CellRenderer, Column } from '@miq/catalog';

@Component({
  selector: 'miq-property-set-statistical-cell-renderer,[miqPropertySetStatisticalCellRenderer]',
  template: `
    <div class="fx--h fx--juc-start fx--ali-center chip">
      <!-- principal column -->
      <ng-container *ngIf="is_statistical">
        <!-- unit -->
        <span
          class="statistical-chip fx--mr-4"
          [matTooltip]="'Statistical Record'"
          matTooltipPosition="above"
          matTooltipClass="tooltip-action-icon"
        >
          S
        </span>
        &nbsp;
      </ng-container>
    </div>
  `,
  styleUrls: ['./property-set-statistical-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PropertySetStatisticalCellRendererComponent implements CellRenderer<Column>, OnInit {
  public data?: Record<string, any> = null;
  public config?: Column;
  is_statistical = false;

  ngOnInit(): void {
    // TODO: inject state provider so we pull the property set fingerprint and find the usage based on it
    this.is_statistical =
      this.data && this.data?.usages.length > 0 ? this.data?.usages.some(usage => usage?.statistical_f) : false;
  }

  render(): void {
    // required by CellRenderer
  }
}
